// Display helpers for a Data QA run, shared by the Data QA table and Request
// Forecast pickers so the run label can't drift between them.
import { instantToUtcTimestamp } from '../../utils/date-utils';
import { DataQaRun } from './useForecastDataQa';

/** e.g. `Run 3f9a21bc · 2026-06-20 18:42 UTC`. */
export const runLabel = (run: DataQaRun): string =>
  `Run ${run.data.data_qa_id.slice(0, 8)} · ${instantToUtcTimestamp(run.generatedAtMs)}`;
